import React from 'react';

interface ExitMessageProps {
  show: boolean;
}

/**
 * Componente para mostrar el mensaje sutil de "double back" para salir
 * Diseño acorde a la app SHC con colores y tipografía consistentes
 */
const ExitMessage: React.FC<ExitMessageProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '80px', // Posicionado cerca de la barra de navegación inferior
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(56, 56, 56, 0.95)', // #383838 con transparencia
        color: '#FFFFFF',
        padding: '16px 24px',
        borderRadius: '12px',
        zIndex: 1300, // Sistema/emergencia (mensaje de salida)
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'normal',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        border: '1px solid rgba(35, 145, 255, 0.3)', // #2391FF con transparencia
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        maxWidth: '280px',
        lineHeight: '1.4',
        animation: 'exitMessageFadeInOut 2.5s ease-in-out',
        pointerEvents: 'none', // No interfiere con la interacción
      }}
    >
      <div style={{ 
        color: '#2391FF', 
        fontSize: '16px', 
        fontWeight: 'bold',
        marginBottom: '4px'
      }}>
        Salir de la aplicación
      </div>
      <div style={{ 
        color: '#FFFFFF', 
        fontSize: '12px',
        opacity: 0.9
      }}>
        Presione 'Atrás' nuevamente para salir
      </div>
    </div>
  );
};

export default ExitMessage;
